(function () {
  const SELECTORS = {
    section: '[data-hc-main-hero-slider]',
    swiper: '[data-hc-main-hero-swiper]',
    pagination: '[data-hc-main-hero-pagination]',
  };

  const instances = new Map();

  function getSwiperConstructor() {
    if (window.Swiper) return window.Swiper;
    return null;
  }

  function initSection(section) {
    if (instances.has(section)) return;

    const SwiperConstructor = getSwiperConstructor();
    const swiperEl = section.querySelector(SELECTORS.swiper);
    const paginationEl = section.querySelector(SELECTORS.pagination);

    if (!SwiperConstructor || !swiperEl) return;

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    const hasMultipleSlides = slides.length > 1;

    const autoplayEnabled = section.dataset.autoplay === 'true';
    const autoplaySpeed = Number(section.dataset.autoplaySpeed || 4000);

    const swiper = new SwiperConstructor(swiperEl, {
      slidesPerView: 1,
      centeredSlides: true,
      rewind: true,
      preventClicks: true,
      preventClicksPropagation: true,
      watchOverflow: true,
      speed: 450,

      pagination: hasMultipleSlides && paginationEl
        ? {
            el: paginationEl,
            clickable: true,
            bulletClass: 'hc-main-hero-slider__bullet',
            bulletActiveClass: 'hc-main-hero-slider__bullet-active',
            renderBullet: function (_index, className) {
              return (
                "<button type='button' name='Pagination bullet' aria-label='Pagination bullet' class='" +
                className +
                "'></button>"
              );
            },
          }
        : false,

      autoplay: autoplayEnabled && hasMultipleSlides
        ? {
            delay: autoplaySpeed,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,
    });

    instances.set(section, swiper);
  }

  function destroySection(section) {
    const swiper = instances.get(section);

    if (!swiper) return;

    swiper.destroy(true, true);
    instances.delete(section);
  }

  function init() {
    document.querySelectorAll(SELECTORS.section).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  document.addEventListener('shopify:section:unload', function (event) {
    const section = event.target.querySelector(SELECTORS.section);

    if (section) {
      destroySection(section);
    }
  });
})();